import { SaleTransactionType } from 'api-hooks/refund/refund';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer,
  SeparatorVertical,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

interface Props {}

export default function AgentDetailField(props: Props) {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { navigate } = useNavigation();

  const key = 'releasePurchase.refId';

  const [transactionOrderType, orderNumber] = useWatch({
    control,
    name: ['transactionOrderType', key],
  });

  const onItemInvoked = React.useCallback(() => {
    let target: NavigationRoutes | undefined;

    switch (transactionOrderType) {
      case SaleTransactionType.ACTIVITY:
        target = NavigationRoutes.ActivityPurchasesView;
        break;
      case SaleTransactionType.CRUISE:
        target = NavigationRoutes.CruisePurchasesView;
        break;
      case SaleTransactionType.DOCUMENT:
        target = NavigationRoutes.DocumentPurchasesView;
        break;
      case SaleTransactionType.FLIGHT:
        target = NavigationRoutes.FlightPurchasesView;
        break;
      case SaleTransactionType.HOTEL:
        target = NavigationRoutes.HotelPurchasesView;
        break;
      case SaleTransactionType.PRODUCT:
        target = NavigationRoutes.ProductPurchasesView;
        break;

      default:
        notification.error({
          message: t('refund:no_selected_extra', {
            extra: t('common:order_number'),
          }),
        });

        return <></>;
    }

    navigate(target as NavigationRoutes, {
      id: orderNumber,
    });
  }, [navigate, orderNumber, t, transactionOrderType]);

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <FullContainer>
        <SectionContainer $style={{ alignItem: 'center' }}>
          <div style={{ flex: 1 }}>
            <Text variant="HeadingXSmall">{t('common:purchase_details')}</Text>
          </div>
          <SeparatorVertical $margin={8} />
          <Button buttonType="secondary" onClick={onItemInvoked}>
            {t('common:view_detail')}
          </Button>
        </SectionContainer>
        <SeparatorVertical $margin={36} />

        <SectionContainer>
          <HalfContainer>
            <Input
              type="date-time"
              name="releasePurchase.transactionAt"
              label={t('common:transaction_at')}
              placeholder={t('common:transaction_at')}
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="number"
              name="releasePurchase.total"
              label={t('common:total')}
              placeholder={t('common:total')}
              disabled
            />
          </HalfContainer>
        </SectionContainer>
        <SectionContainer>
          <HalfContainer>
            <Input
              type="text"
              label={t('common:agent')}
              placeholder={t('common:agent')}
              name="releasePurchase.agent"
              disabled
            />
          </HalfContainer>
          <HalfContainer>
            <Input
              type="text"
              label={t('common:payment_via')}
              placeholder={t('common:payment_via')}
              name="releasePurchase.paymentChannel"
              disabled
            />
          </HalfContainer>
        </SectionContainer>
      </FullContainer>
    </CardSection>
  );
}
